import { render, staticRenderFns } from "./industryTrends.vue?vue&type=template&id=cef0771e&scoped=true&"
import script from "./industryTrends.vue?vue&type=script&lang=js&"
export * from "./industryTrends.vue?vue&type=script&lang=js&"
import style0 from "./industryTrends.vue?vue&type=style&index=0&id=cef0771e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef0771e",
  null
  
)

export default component.exports